import { Filters, SelectItem } from '@/types';

export namespace Subpartners {
  export enum Pages {
    SUBPARTNERS = 'subpartners',
    SUBPARTNER_DETAIL = 'subpartner',
    SUBPARTNER_EDIT = 'subpartner-edit',
    SUBPARTNERS_SALES = 'subpartners/sales',

    SUBPARTNERS_SALES_ALERT = 'subpartners_sales',
  }

  export interface Subpartner {
    [key: string]: unknown,
    id?: number,
    name_subpartner: string,
    inn_subpartner: string,
    kpp_subpartner?: string,
    city: string,
    region: string,
    email: string,
    contact_person: string,
    telephone: string,
  }

  export interface SubpartnerSales extends Subpartner {
    date_sale: string,
    code: number,
    nomenclature: string,
    quantity: number,
    price: number
  }
}

export interface SubpartnersFilters extends Filters {
  [key: string]: unknown;
}

export interface SubpartnerFileUploadData {
  fail_rows: number | null;
  success_rows: number | null;
  total_rows: number | null;
}
